'use strict';

var _ = require('lodash');
function ConfigurationDiscontinuedRoutesService($http, restangular, fileSaveService, momentService) {
  var csvHeaders = ['ROUTE', 'START DATE', 'END DATE', 'CONNECTING SERVICES'];
  var fieldsToExport = ['route', 'departureDateRangeStart', 'departureDateRangeEnd', 'connectingServices'];
  var ALL_SEGMENTS_INTERFIX = ' (all) ';
  var discontinuedRouteRest = restangular.one('domain').all('discontinuedRoute');
  function deleteUnneededAttributes(entity) {
    delete entity._old;
    delete entity.originalRowId;
    delete entity._links;
    delete entity.uid;
  }
  function transformDates(row, eventTimeStamp) {
    row.departureDateRangeStart = row.departureDateRangeStart ? row.departureDateRangeStart.format(momentService.FORMAT.DATE_ISO) : undefined;
    row.departureDateRangeEnd = row.departureDateRangeEnd ? row.departureDateRangeEnd.format(momentService.FORMAT.DATE_ISO) : undefined;
    row.eventTimeStamp = row.eventTimeStamp ? row.eventTimeStamp.toISOString() : eventTimeStamp.toISOString();
  }
  function save(rowsToSave) {
    var eventTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    var payloadEntity = _.transform(rowsToSave, function (result, row) {
      var clonedRow = _.clone(row);
      deleteUnneededAttributes(clonedRow);
      transformDates(clonedRow, eventTimeStamp);
      result.push(clonedRow);
    });
    return discontinuedRouteRest.customPUT(payloadEntity);
  }
  function remove(rowsToRemove) {
    var eventTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    _.forEach(rowsToRemove, function (row) {
      deleteUnneededAttributes(row);
      transformDates(row, eventTimeStamp);
    });
    return $http({
      method: 'DELETE',
      url: discontinuedRouteRest.getRestangularUrl(),
      data: rowsToRemove,
      headers: {
        'Content-Type': 'application/json;charset=UTF-8'
      }
    });
  }
  function exportToCsv(data) {
    var payload = createCsvHeader(csvHeaders);
    var eventTimeStamp = momentService.now(momentService.FIELD.EVENT_TIME_STAMP);
    payload = _.reduce(data, function (result, discontinuedRoute) {
      var exportedRoute = _.clone(discontinuedRoute);
      transformDates(exportedRoute, eventTimeStamp);
      removeAllSegmentsInterfix(exportedRoute);
      result += createCsvRow(exportedRoute, fieldsToExport);
      return result;
    }, payload);
    fileSaveService.createFile(payload, 'text/csv', 'DiscontinuedRoutes.csv');
  }
  function removeAllSegmentsInterfix(exportedRoute) {
    if (exportedRoute.route) {
      exportedRoute.route = exportedRoute.route.replace(ALL_SEGMENTS_INTERFIX, '-');
    }
  }
  function createCsvRow(row, fieldsToExport) {
    var valuesToExport = [];
    _.each(fieldsToExport, function (fieldName) {
      valuesToExport.push(row[fieldName]);
    });
    return formatAsCsvRow(valuesToExport);
  }
  function createCsvHeader(csvHeaders) {
    return formatAsCsvRow(csvHeaders);
  }
  function formatAsCsvRow(stringArrayToFormat) {
    var rowValues = _.chain(stringArrayToFormat).map(function (value) {
      return value || '';
    }).toString().value();
    return rowValues + '\r\n';
  }
  return {
    save: save,
    remove: remove,
    exportToCsv: exportToCsv
  };
}
ConfigurationDiscontinuedRoutesService.$inject = ['$http', 'Restangular', 'FileSaveService', 'MomentService'];
module.exports = ConfigurationDiscontinuedRoutesService;